const sponsored = [
  {
    name: 'Learn German with the DW',
    subscribers: '483K',
    banner: 'learn-german-dw.jpg',
    avatar: 'learn-german-dw.jpg',
    link: 'https://www.youtube.com/user/dwlearngerman',
  },
  {
    name: 'Blender Guru',
    subscribers: '1.32M',
    banner: 'blender-guru.jpg',
    avatar: 'blender-guru.jpg',
    link: 'https://www.youtube.com/user/AndrewPPrice',
  },
  {
    name: 'Flux',
    subscribers: '168K',
    banner: 'flux.jpg',
    avatar: 'flux.jpg',
    link: 'https://www.youtube.com/channel/UCN7dywl5wDxTu1RM3eJ_h9Q',
  },
  {
    name: 'Tech Dummies',
    subscribers: '66.1K',
    banner: 'tech-dummies.jpg',
    avatar: 'tech-dummies.jpg',
    link: 'https://www.youtube.com/channel/UCn1XnDWhsLS5URXTi5wtFTA',
  },
  {
    name: 'Khan Academy',
    subscribers: '5.75M',
    banner: 'khan-academy.jpg',
    avatar: 'khan-academy.jpg',
    link: 'https://www.youtube.com/user/khanacademy',
  },
  {
    name: 'Brackeys',
    subscribers: '1.13M',
    banner: 'brackeys.jpg',
    avatar: 'brackeys.jpg',
    link: 'https://www.youtube.com/user/Brackeys',
  },
  {
    name: 'freeCodeCamp.org',
    subscribers: '2.15M',
    banner: 'free-code-camp.jpg',
    avatar: 'free-code-camp.jpg',
    link: 'https://www.youtube.com/channel/UC8butISFwT-Wl7EV0hUK0BQ',
  },
];

export default sponsored;
